import InstallAppPrompt from './components/InstallAppPrompt';
import { applyAppBranding, PRODUCT_BRAND } from "./appBranding";
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { registerServiceWorkerUpdates } from './serviceWorkerUpdates';

// Error tracking (Tier 2 of the federation roadmap). A no-op if
// REACT_APP_SENTRY_DSN isn't set at build time — CRA only exposes env
// vars prefixed REACT_APP_ to the client bundle. Get a free DSN at
// https://sentry.io (React platform) and set REACT_APP_SENTRY_DSN in
// .env / your build environment to turn this on.
// Sentry's browser SDK auto-captures fetch/XHR breadcrumbs, which would
// otherwise include the x-auth-token header this app sends on every
// request (see src/api.js) verbatim in an error report. Scrubbed
// explicitly rather than trusting SDK defaults, same reasoning as the
// backend's instrument.js.
const SENSITIVE_HEADER_KEYS = ['x-auth-token', 'authorization', 'cookie'];
function scrubBreadcrumb(breadcrumb) {
  const headers = breadcrumb?.data?.request_headers || breadcrumb?.data?.headers;
  if (headers) {
    for (const key of Object.keys(headers)) {
      if (SENSITIVE_HEADER_KEYS.includes(key.toLowerCase())) headers[key] = '[redacted]';
    }
  }
  return breadcrumb;
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || '',
  environment: process.env.NODE_ENV || 'development',
  enabled: process.env.NODE_ENV === 'production' && !!process.env.REACT_APP_SENTRY_DSN,
  // Modest sampling — an internal business tool doesn't need full
  // session/performance tracing, and it eats into Sentry's free-tier
  // event quota fast.
  tracesSampleRate: 0.1,
  beforeBreadcrumb: scrubBreadcrumb,
});


registerServiceWorkerUpdates('/sw.js');

// Without this, a render-time crash anywhere in the tree used to just
// show a blank white screen with nothing in the UI to explain it and no
// record of it happening — the person using the ERP had no way to
// recover except guessing to hit refresh, and we'd never know it
// happened unless they specifically reported it.
function ErrorFallback({ error, eventId, resetError }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 14, padding: 24, textAlign: 'center', fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{ fontSize: 40 }}>⚠️</div>
      <h1 style={{ fontSize: 20, margin: 0 }}>Something went wrong</h1>
      <p style={{ color: '#666', maxWidth: 420, margin: 0, fontSize: 14, lineHeight: 1.6 }}>
        This page hit an unexpected error. It's been reported automatically — reloading usually fixes it.
      </p>
      {eventId && (
        <p style={{ color: '#999', fontSize: 12 }}>Reference: {eventId}</p>
      )}
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 20px', borderRadius: 8, border: 'none', background: '#2563eb',
          color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer',
        }}
      >
        Reload page
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
    <App />
  </Sentry.ErrorBoundary>
);
// Product identity is code-owned and cannot be replaced by platform/admin settings.\napplyAppBranding();\n\nconst installHost=document.createElement("div");installHost.id="pwa-install-prompt";document.body.appendChild(installHost);const installRoot=ReactDOM.createRoot(installHost);installRoot.render(<InstallAppPrompt appName={PRODUCT_BRAND.name} logoUrl={PRODUCT_BRAND.appIcon}/>);
